<template>
  <div
    class="filter-category | sidebar-menu"
    v-if="navigation.tree && navigation.tree.length"
  >
    <ul class="sidebar-menu__list">
      <li
        v-for="(category, index) in navigation.tree"
        :key="category.categoryName + '_' + index"
        class="sidebar-menu__item"
      >
        <a
          class="sidebar-menu__link"
          :class="{
            'sidebar-menu__link--active': category.selected
          }"
          :href="category.url"
        >
          <span v-html="category.categoryName" />
          <!--<span class="sidebar-menu__link-addition">({{ category.count }})</span>-->
        </a>
        <ul
          v-if="showChildren(category)"
          class="sidebar-menu__list"
        >
          <li
            v-for="(child, i) in category.children"
            :key="category.categoryName + '_' + index + '_' + i"
            class="sidebar-menu__item"
          >
            <a
              class="sidebar-menu__link"
              :class="{
                'sidebar-menu__link--active': child.selected
              }"
              :href="child.url"
            >
              <span v-html="child.categoryName" />
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
  import plpStateComputedMixin from '../../utilities/vueMixins/plpStateComputedMixin/plpStateComputedMixin.js';

  export default {
    mixins: [
      plpStateComputedMixin
    ],
    props: {
      showAllSubCategories: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        defaultCategory: '',
      };
    },
    methods: {
      isChildCategorySelected(categoryChildren) {
        if (categoryChildren) {
          return categoryChildren.some(option => option.selected === true);
        }
      },
      everyCategoryUnselected() {
        return this.navigation.tree.every(category => category.selected === false);
      },
      everyChildUnselected() {
        const childrenSelected = [];
        this.navigation.tree.forEach(category => {
          if (category.children) {
            category.children.forEach(option => {
              childrenSelected.push(option.selected);
            });
          }
        });
        return childrenSelected.every(value => value === false);
      },
      isDefaultOpen(category) {
        if (category.children && (this.defaultCategory === '' || this.defaultCategory === category.categoryName)) {
          if (this.defaultCategory === '') {
            this.defaultCategory = category.categoryName;
          }
          return this.everyCategoryUnselected() && this.everyChildUnselected();
        }
      },
      showChildren(category) {
        const hasChildren = category.children;
        const isSelectedOrHasSelectedChildOrIsDefaultOpen = category.selected
          || this.isChildCategorySelected(category.children)
          || this.isDefaultOpen(category);

        return hasChildren && (isSelectedOrHasSelectedChildOrIsDefaultOpen || this.showAllSubCategories);
      }
    }
  };

</script>
